
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import AlertModule from 'vux/src/plugins/alert/module'
import Loading from 'vux/src/components/loading/index.vue'

let moment = require('moment')
export default {
name: 'punch-the-clock',
directives: {
TransferDom
},
data () {
return {
info: {},
timeDate: '',
dateTime: '',
timrer: null,
inScope: true,
currentDate: '',
visibility: false,
showToast: false,
cameraImages: false,
curCameraImg: '',
uploadFile: null,
showLoad: false,
center: {
lng: 0,
lat: 0
},
zoom: 3,
pointPosition: {},
panceInfo: [],
indexCur: '',
selTraceId: '7',
curAddress: '',
curLng: '',
curLat: ''
}
},
mounted () {
clearInterval(this.timrer)
this.getUserInfo()
this.getTime()
this.getTimeDate()
this.timrer = setInterval(() => {
this.getTime()
this.getTimeDate()
}, 1000)


},
methods: {
handler ({ BMap, map }) {
console.log(BMap)
this.center.lng = 117.230135
this.center.lat = 31.826333
this.zoom = 15
console.log(11)
setTimeout(() => {
this.showPosition()
}, 500)
},
getTimeDate () {
const date = new Date()
let h = date.getHours()
let m = date.getMinutes()
let s = date.getSeconds()
if (h >= 1 && h <= 9) {
h = '0' + h
}
if (m >= 0 && m <= 9) {
m = '0' + m
}
if (s >= 0 && s <= 9) {
s = '0' + s
}
this.timeDate = h + ':' + m + ':' + s

},
getTime () {
const date = new Date()
const year = date.getFullYear()
let month = date.getMonth() + 1
let strDate = date.getDate()
if (month >= 1 && month <= 9) {
month = '0' + month
}
if (strDate >= 0 && strDate <= 9) {
strDate = '0' + strDate
}
const currentdate = year + '-' + month + '-' + strDate
return currentdate
},
getUserInfo () {
this.info = JSON.parse(localStorage.getItem('loginUser'))
if (this.info) {
this.getUserTrace()
} else {
this.$router.push({ path: '/login' })
}
},
getUserTrace () {
this.$axios.post('/shuian/public/mobile/trace/selTrace', { 'date': this.currentDate })
.then(res => {

if (res.data.code === 200) {
this.dateTime = res.data.data.reverse()
if (res.data.data.length > 0) {
this.selTraceId = res.data.data[0].type

}
this.showLoad = false
} else {
this.$router.push({ path: '/login' })
}
})
.catch(error => {
this.$router.push({ path: '/login' })
console.log(error)
})
},
getDate (date) {
return moment(date).format('HH:mm:ss')
},
cancelDate () {
console.log('取消')
},
confirmDate () {
this.getUserTrace()
console.log('确定')
},
showPlugin () {
this.visibility = true
},
showCameraDialog () {
this.showToast = true
},
choiceImg () {
let self = this
if (!window.plus) {
self.addPic() 
return
}

let title = '选择照片'
let btns = ['拍照', '相册']

var func = function (e) {
var index = e.index

if (index === 1) self.choiceCamera()
if (index === 2) self.choicePic()
}

if (title && btns && btns.length > 0) {
let btnArray = []
for (var i = 0; i < btns.length; i++) {
btnArray.push({ title: btns[i] })
}

plus.nativeUI.actionSheet({
title: title,
cancel: '取消',
buttons: btnArray
}, function (e) {
if (func) func(e)
})
}
},
choiceCamera () {
let self = this
var cmr = plus.camera.getCamera()
cmr.captureImage(function (path) {
plus.io.resolveLocalFileSystemURL(path, function (entry) {
self.curCameraImg = entry.toLocalURL()
}, function (e) { plus.nativeUI.toast('读取拍照文件错误：' + e.message) })
}, function (e) {}, { index: 1, filename: '_doc/camera/' })
},
choicePic () {
let self = this
plus.gallery.pick(function (p) {
plus.io.resolveLocalFileSystemURL(p, function (entry) {
self.curCameraImg = entry.toLocalURL()
}, function (e) {
plus.nativeUI.toast('读取拍照文件错误：' + e.message)
})
}, function (e) { plus.nativeUI.toast('读取拍照文件错误：' + e.message) }, {
filename: '_doc/camera/',
filter: 'image'
})
},
addPic: function (e) {
let els = this.$refs.divGenres.querySelectorAll('input[type=file]')
els[0].click()
return false
},
onFileChange (e) {
console.log(e)
let self = this
let files = e.target.files || e.dataTransfer.files
if (!files.length) return
let file = files[0] 
self.uploadFile = file
let reader = new FileReader()
reader.readAsDataURL(file)
reader.onload = function (e) {
self.curCameraImg = e.target.result
self.cameraImages = true
}
},
upload () {
this.cameraImages = false
var self = this
var wt
if (window.plus) wt = plus.nativeUI.showWaiting()
var img = new Image,
width = 300,
quality = 0.01,
canvas = document.createElement('canvas'),
drawer = canvas.getContext('2d')
img.src = self.curCameraImg
img.onload = function () {
canvas.width = width
canvas.height = width * (img.height / img.width)
drawer.drawImage(img, 0, 0, canvas.width, canvas.height)
var base64 = canvas.toDataURL('image/*', quality)
var pic = base64.split(',')[1]
var f = self.curCameraImg
var filename = f.replace(f.substring(0, f.lastIndexOf('/') + 1), '')
if (self.uploadFile !== null) {
filename = self.uploadFile.name
let reader = new FileReader()
reader.readAsDataURL(self.uploadFile)
reader.onload = function (e) {
img.src = e.target.result
}
img.onload = function () {
canvas.width = width
canvas.height = width * (img.height / img.width)
drawer.drawImage(img, 0, 0, canvas.width, canvas.height)
base64 = canvas.toDataURL('image/*', quality)
pic = base64.split(',')[1]
}
}
self.showLoad = true
const imgSrc = img.src.split(',')
const curImgSrc = imgSrc[1]
console.log(curImgSrc)
self.addTrace(self.panceInfo[self.indexCur].id, pic)





































}
},
addTrace (fenceId, pic) {
let traceId = ''
if (this.selTraceId === '6') {
traceId = '7'
} else if (this.selTraceId === '7') {
traceId = '6'
} else {
traceId = '6'
}
const parmas = {
'base64': pic,
'fence_id': fenceId,
'trace_type': traceId
}
this.$axios.post('/shuian/public/mobile/trace/addTrace2', parmas)
.then(res => {
if (res.data.code === 200) {
this.getUserTrace()
this.curCameraImg = ''
this.showToast = false
} else {
this.showLoad = false
this.curCameraImg = ''
AlertModule.show({
title: '提示',
content: res.data.codeInfo,
buttonText: '确定'
})
}
})
.catch(error => {
console.log(error)
})
},
cancelToast () {
this.cameraImages = false
this.curCameraImg = ''
this.showToast = false
},
showPosition () {
console.log(222)
const that = this
const geoc = new BMap.Geocoder()
console.log('333', geoc)
if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
const geolocation1 = new BMap.Geolocation()
console.log(444)
let lng = '' 
let lat = ''
geolocation1.getCurrentPosition(function (r) {

if (this.getStatus() == BMAP_STATUS_SUCCESS) {
lng = r.point.lng 
lat = r.point.lat 
that.curLng = lng
that.curLat = lat
that.getFence(lng, lat)
console.log(geoc)
const point = new BMap.Point(lng, lat)
geoc.getLocation(point, function (rs) {
console.log(1)
console.log(rs)
that.curAddress = rs.address
})
} else {
alert('浏览器定位 failed 状态 ')
}
}, {
enableHighAccuracy: true
})
} else if (navigator.userAgent.match(/android/i)) {

if (navigator.geolocation) {


navigator.geolocation.getCurrentPosition(function (pos) {

var x = pos.coords.longitude
var y = pos.coords.latitude

var gpsPoint = new BMap.Point(x, y)

const convertor = new BMap.Convertor() 
const pointArr = []
pointArr.push(gpsPoint)
convertor.translate(pointArr, 1, 5, function (data) {


that.curLng = data.points[0].lng
that.curLat = data.points[0].lat
that.getFence(data.points[0].lng, data.points[0].lat)
const point = new BMap.Point(data.points[0].lng, data.points[0].lat)
geoc.getLocation(point, function (rs) {
console.log(rs)
that.curAddress = rs.address
})
})
})
} else {
alert('不支持定位')
}
}
},
getFence (lng, lat) {
const pance = JSON.parse(localStorage.getItem('fenceList'))
this.panceInfo = pance
if (pance.length > 0) {
const point = []
const polygon = []
pance.forEach(item => {
point.push(JSON.parse(item.point))
})

point.forEach(item => {
item.forEach(poly => {
polygon.push(poly.polygon)
})
})
const pt = new BMap.Point(lng, lat)


let ply = ''
let res = false



for (let i = 0; i < polygon.length; i++) {
var pts = []
for (let j = 0; j < polygon[i].length; j++) {
var pt1 = new BMap.Point(polygon[i][j].lng, polygon[i][j].lat)
pts.push(pt1)
}
ply = new BMap.Polygon(pts)

res = BMapLib.GeoUtils.isPointInPolygon(pt, ply)

if (res) {

this.indexCur = i
break
}
}
console.log('rrrr', res)
if (res) {
this.inScope = false
} else {
this.inScope = true
}
} else {
AlertModule.show({
title: '提示',
content: '请联系管理员配置电子围栏信息',
buttonText: '确定'
})
}
},
resPosition () {
this.$axios.post('/shuian/public/mobile/trace/selFence', {})
.then(res => {
if (res.data.code === 200) {
localStorage.setItem('fenceList', JSON.stringify(res.data.data.fence))
} else {
this.$router.push({ path: '/login' })
}
})
.catch(error => {
console.log(error)
})
this.showPosition()
}
},
components: {
Datetime, XDialog, Loading, BaiduMap, BmMarker
},
computed: {
},
watch: {
handler ({ BMap }) {

}
}
}
